// @flow
import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {INSTANT_BOOK__16} from '@homeaway/svg-defs';

import type {IntlShape} from 'react-intl';

export default function InstantBookIcon({intl}: {intl: IntlShape}) {
    return (
        <span
            className="InstantBookIcon"
            aria-hidden="true"
            title={intl.formatMessage({
                id: 'instantConfirmationSecondaryLabel',
                defaultMessage: 'Book without waiting for owner approval'
            })}
        >
            <SVGIcon markup={INSTANT_BOOK__16} inline />
        </span>
    );
}
